import React, { useState } from 'react'
import '../../stylesheets/home/home.css'
import useAuthServer from"../../hooks/external/vendor/auth/useAuthServer.js"
import TermsOfService from './TermsOfService'


const Home = () => {

    const { handleLogin} = useAuthServer()
    const [showTerms, setShowTerms] = useState(false)


    // Generate random financial data for background animation
    const generateFinancialData = () => {
        const data = [];
        const metrics = [
            { label: 'P/E', range: [10, 35] },
            { label: 'EV/EBITDA', range: [8, 25] },
            { label: 'EV/Sales', range: [1, 8] },
            { label: 'P/B', range: [1, 5] },
            { label: 'ROE', range: [5, 30] },
            { label: 'ROA', range: [3, 20] },
            { label: 'WACC', range: [4, 12] },
            { label: 'Beta', range: [0.5, 2.0] },
            { label: 'D/E', range: [0.2, 2.5] },
            { label: 'FCF Yield', range: [2, 15] },
            { label: 'ROIC', range: [5, 25] },
            { label: 'EBITDA Margin', range: [10, 40] },
            { label: 'Net Margin', range: [5, 25] },
            { label: 'Asset Turnover', range: [0.5, 3.0] },
            { label: 'Current Ratio', range: [1, 3] },
            { label: 'Quick Ratio', range: [0.5, 2.5] }
        ];

        for (let i = 0; i < 40; i++) {
            const metric = metrics[Math.floor(Math.random() * metrics.length)];
            const value = (Math.random() * (metric.range[1] - metric.range[0]) + metric.range[0]).toFixed(2);
            const change = (Math.random() * 10 - 5).toFixed(2);
            const isPositive = parseFloat(change) >= 0;
            
            data.push({
                id: i,
                label: metric.label,
                value: value,
                change: change,
                isPositive: isPositive,
                top: Math.random() * 100,
                left: Math.random() * 100,
                delay: Math.random() * 2,
                duration: 1.5 + Math.random() * 1
            });
        }
        return data;
    };

    const financialData = generateFinancialData();

    return (
        <>
        <div className="landing-page-wrapper">
            {/* Sibling #1 - Container for Animation Background inside page-wrapper */}
            <div className="animated-background" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0.25,
                pointerEvents: 'none',
                overflow: 'hidden',
                zIndex: 0
            }}>
                {financialData.map((item) => (
                    <div
                        key={item.id}
                        style={{
                            position: 'absolute',
                            top: `${item.top}%`,
                            left: `${item.left}%`,
                            color: item.isPositive ? '#1abc9c' : '#c0392b',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: 'monospace',
                            animation: `pulse ${item.duration}s ease-in-out infinite`,
                            animationDelay: `${item.delay}s`,
                            whiteSpace: 'nowrap',
                            textShadow: '0 2px 8px rgba(0,0,0,0.6)'
                        }}
                    >
                        <div style={{ fontSize: '12px', opacity: 0.9 }}>{item.label}</div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{item.value}</div>
                        <div style={{ fontSize: '14px', opacity: 0.95 }}>
                            {item.isPositive ? '▲ +' : '▼ '}{item.change}%
                        </div>
                    </div>
                ))}
            </div>

            {/* Sibling #2 - Container for Page Content */}
            <div className="landing-content">
                <div className="hero-section">
                    {/* Single Row Wrapper: with two columns */}
                    <div className="hero-row-1">
                        {/* Left Column Wrapper: Hero Page Title and Auth Card */}
                        <div className="hero-left-column">
                            {/* Hero Page Title */}
                            <div className="hero-content">
                                <h1 className="hero-title">PulseRank</h1>
                                <p className="hero-subtitle">by Pulse Rank Labs</p>
                            </div>
                            
                            {/* Auth Card */}
                            <div className="auth-card">
                                <div className="auth-card-header">
                                    <h2 className="auth-card-title">Built by Professionals, For Use by Everyone</h2>
                                    <p className="auth-card-description"></p>
                                </div>
                                
                                <div className="auth-card-button-wrapper">
                                    <button className="auth-button auth-button-primary"
                                        onClick={handleLogin}
                                    >
                                        Sign In / Sign Up
                                    </button>
                                </div>

                                <div className="auth-card-footer">
                                    <p className="auth-card-footer-text" onClick={() => setShowTerms(true)} style={{cursor: 'pointer'}}>
                                        Terms and Conditions
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        {/* Right Column Wrapper: Visual Elements */}
                        <div className="hero-right-column">
                            {/* Visual Elements */}
                            <div className="hero-visual">
                                {/* Floating Card 1 */}
                                <div className="floating-card card-1">
                                    <div className="card-label">Revenue Growth</div>
                                    <div className="card-value">+24.5%</div>
                                    <svg className="mini-chart" viewBox="0 0 60 30" fill="none">
                                        <rect x="2" y="18" width="8" height="12" fill="#10b981" rx="1"/>
                                        <rect x="14" y="14" width="8" height="16" fill="#10b981" rx="1"/>
                                        <rect x="26" y="10" width="8" height="20" fill="#10b981" rx="1"/>
                                        <rect x="38" y="6" width="8" height="24" fill="#10b981" rx="1"/>
                                        <rect x="50" y="3" width="8" height="27" fill="#10b981" rx="1"/>
                                    </svg>
                                </div>
                                
                                {/* Floating Card 2 */}
                                <div className="floating-card card-2">
                                    <div className="card-label">P/E Ratio</div>
                                    <div className="card-value">18.2x</div>
                                    <div className="metric-bar">
                                        <div className="metric-fill" style={{width: '72%'}}></div>
                                    </div>
                                </div>
                                
                                {/* Floating Card 3 */}
                                <div className="floating-card card-3">
                                    <div className="card-label">Market Cap</div>
                                    <div className="card-value">$2.4B</div>
                                    <svg className="mini-chart" viewBox="0 0 60 30" fill="none">
                                        <path d="M0 28 L10 25 L20 20 L30 22 L40 15 L50 12 L60 5" 
                                              stroke="#3b82f6" strokeWidth="2" fill="none"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Feature Cards Section */}
                {/*
                <div className="features-section">
                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 11l3 3L22 4"></path>
                                <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
                            </svg>
                        </div>
                        <h3 className="feature-title">Public Comparables</h3>
                        <p className="feature-description">
                            Analyze publicly traded companies with real-time market data. Compare valuation multiples and financial metrics across sectors.
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <h3 className="feature-title">Transaction Comps</h3>
                        <p className="feature-description">
                            Access comprehensive M&A transaction data and precedent deals. Understand market valuations before you analyze.
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M3 3v18h18"></path>
                                <path d="M18 17V9"></path>
                                <path d="M13 17V5"></path>
                                <path d="M8 17v-3"></path>
                            </svg>
                        </div>
                        <h3 className="feature-title">Football Field</h3>
                        <p className="feature-description">
                            Compare multiple valuation methodologies side-by-side. Visualize valuation ranges and build investment theses.
                        </p>
                    </div>
                </div>
                */}
                {/* How It Works Section */}
                {/*
                <div className="how-it-works-section">
                    <h2 className="section-title">How It Works</h2>
                    
                    <div className="steps-container">
                        <div className="step-card">
                            <div className="step-number">1</div>
                            <h3 className="step-title">Select Your Analysis</h3>
                            <p className="step-description">
                                Choose from Public Comparables, Transaction Comps, or Football Field analysis to begin your valuation.
                            </p>
                        </div>
                        <div className="step-card">
                            <div className="step-number">2</div>
                            <h3 className="step-title">Configure Parameters</h3>
                            <p className="step-description">
                                Select companies, sectors, and metrics. Customize your analysis with relevant filters and criteria.
                            </p>
                        </div>
                        <div className="step-card">
                            <div className="step-number">3</div>
                            <h3 className="step-title">Generate Insights</h3>
                            <p className="step-description">
                                Get instant visualizations and reports. Export data ready for presentations and investment memos.
                            </p>
                        </div>
                    </div>
                </div>
                */}
            </div>
        </div>
        {showTerms && <TermsOfService onShowTermsChange={setShowTerms} />}
        </>
    );
};

export default Home